module.exports = __webpack_public_path__ + "static/wiliquor.409dc315.jpg";